import {
    CreateAddressMutation,
    CreateCustomerMutation,
    UpdateAddressMutation,
    UpdateCustomerMutation,
} from "@/API";
import * as customQueries from "@/customGraphql/queires";
import * as queries from "@/graphql/queries";
import { ICustomer, ICustomerData } from "@/entities";
import { Customer } from "@/entities/customer";
import { Address, IAddress } from "@/entities/user/address";
import * as mutations from "@/graphql/mutations";
import * as customMutations from "@/customGraphql/mutations";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { API, graphqlOperation } from "aws-amplify";
import { ICustomerRepository } from "./customer.types";
import date from 'quasar/src/utils/date.js';;
import { IListCustomer } from "@/entities/listCustomer/listCustomer.types";
import { ListCustomer } from "@/entities/listCustomer";

export class CustomerAPIRepository implements ICustomerRepository {
    async list(saleID: string): Promise<ICustomer[]> {
        const result = (await API.graphql({
            ...graphqlOperation(customQueries.getSaleWithCustomer, {
                id: saleID,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;

        console.log(result);

        return [];
    }

    async searchByPhone(
        keyword: string,
        nextToken?: string
    ): Promise<IListCustomer> {
        const result = (await API.graphql({
            ...graphqlOperation(queries.listCustomers, {
                filter: { phone_number: { contains: keyword } },
                limit: 10000,
                nextToken: nextToken,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;

        // console.log(result.data.listCustomers.items);
        return new ListCustomer(result.data.listCustomers);
    }

    async searchByName(
        keyword: string,
        nextToken?: string
    ): Promise<IListCustomer> {
        const result = (await API.graphql({
            ...graphqlOperation(queries.listCustomers, {
                filter: { firstname: { contains: keyword } },
                limit: 10000,
                nextToken: nextToken,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;

        // console.log(result.data.listCustomers.items);
        return new ListCustomer(result.data.listCustomers);
    }

    async searchByEmail(
        keyword: string,
        nextToken: string
    ): Promise<IListCustomer> {
        const result = (await API.graphql({
            ...graphqlOperation(queries.listCustomers, {
                filter: { email: { contains: keyword } },
                limit: 10000,
                nextToken: nextToken,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;

        // console.log(result.data.listCustomers.items);
        return new ListCustomer(result.data.listCustomers);
    }

    async get(id: string): Promise<ICustomer | undefined> {
        // const result = (await API.graphql(
        //     graphqlOperation(queries.getSaleWithCustomer, {
        //         id,
        //     })
        // )) as any;

        // const u = (result?.data as GetSaleQuery).getSale;
        // const user: any = u;

        // if (u) {
        //     // if (u.bots) {
        //     //     user.bots = u.bots.items;
        //     // }
        //     return new Sale(user);
        // }
        return;
    }

    async create(data: ICustomerData, saleID: string): Promise<ICustomer> {
        console.log("create input:", data, saleID);

        // create customer
        const input: any = {
            ...data,
        };
        delete input.address;
        if (input.email == null) {
            delete input.email;
        }
        const result = (await API.graphql({
            ...graphqlOperation(mutations.createCustomer, {
                input,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as GraphQLResult;

        const c = (result.data as CreateCustomerMutation).createCustomer;
        const customer = new Customer(c);

        // create customer's address
        const addressResult = (await API.graphql({
            ...graphqlOperation(mutations.createAddress, {
                input: {
                    customerID: customer.id,
                    ...data.address,
                },
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as GraphQLResult;
        const a = (addressResult.data as CreateAddressMutation).createAddress;
        const addr = new Address(a as any);
        console.log({ addressResult });

        console.log({ customer }, { addr });
        customer.address.push(addr);

        // create SaleCustomer
        await this.createSaleCustomer(customer.id!, saleID);
        // const saleCustomerResult = await API.graphql(
        //     graphqlOperation(mutations.createSaleCustomers, {
        //         input: {
        //             customerID: customer.id,
        //             saleID: saleID,
        //         },
        //     })
        // );
        // console.log({ saleCustomerResult });

        return customer;
    }

    async update(data: ICustomerData): Promise<ICustomer> {
        // create customer
        const input: any = {
            ...data,
        };
        delete input.address;
        const result = (await API.graphql({
            ...graphqlOperation(customMutations.updateCustomer, {
                input,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS"
            },
        })) as GraphQLResult;

        const c = (result.data as UpdateCustomerMutation).updateCustomer;
        return new Customer(c);
    }

    // TODO update customer address
    async updateAddress(address: IAddress): Promise<IAddress> {
        const input: any = {
            ...address,
        };
        const result = (await API.graphql({
            ...graphqlOperation(mutations.updateAddress, {
                input,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as GraphQLResult;

        const a = (result.data as UpdateAddressMutation).updateAddress;

        return new Address(a as any);
    }

    async delete(id: string): Promise<void> {
        await API.graphql({
            ...graphqlOperation(mutations.deleteCustomer, {
                id,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        });
        return;
    }

    async createSaleCustomer(
        customerID: string,
        saleID: string
    ): Promise<void> {
        await API.graphql({
            ...graphqlOperation(mutations.createSaleCustomers, {
                input: {
                    customerID,
                    saleID,
                },
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        });
    }
}
